import { render, staticRenderFns } from "./TypeOfProgramList.vue?vue&type=template&id=1facf6ba"
import script from "./TypeOfProgramList.vue?vue&type=script&lang=js"
export * from "./TypeOfProgramList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports